import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'

import { cn } from '../../lib/utils'

const containerVariants = cva('mx-auto w-full px-2 sm:px-4 lg:px-6', {
  variants: {
    size: {
      full: 'max-w-none',
      prose: 'max-w-4xl',
      content: 'max-w-6xl',
      wide: 'max-w-[1480px]',
    },
  },
  defaultVariants: {
    size: 'content',
  },
})

type ContainerProps = React.ComponentProps<'div'> & VariantProps<typeof containerVariants>

function Container({ className, size, ...props }: ContainerProps) {
  return (
    <div data-slot="container" className={cn(containerVariants({ size }), className)} {...props} />
  )
}

export { Container, containerVariants, type ContainerProps }
